import Default from "./VariableSetsRoutes";
export * from "./VariableSetsRoutes";

export default Default;
